import React from 'react'
import './Partenairessection.css'
import DecathlonSection from './DecathlonSection'
import CDF from './assets/CDF.jpg'
import bde from './assets/bde.png'
import HDF from './assets/Logo_Region_HDF.jpg'
import compi from './assets/logo-Compiegne.jpg'
import cvec from './assets/logo_cvec.png'
import utc from './assets/logo_utc.png'
import crous from './assets/logo_crous.png'


function Partenairessection () {
  return(
    <div className="Partenaires-section">
      <div className="Decathlon-section-title">
        <hr style={{width:'25vw'}}></hr>
        <h1>NOTRE PARTENAIRE</h1>
        <hr style={{width:'25vw'}}></hr>
      </div>
      <DecathlonSection />
      <div className="Partenaires-section-title">
        <hr style={{width:'25vw'}}></hr>
        <h1>EN ASSOCIATION AVEC</h1>
        <hr style={{width:'25vw'}}></hr>
      </div>
      <div className="Partenaires-section-content">
        <div className="Partenaires-container-row">
          <div className="Partenaires-container">
              <img width="150%" height="150%" src={CDF} alt="CDF" />
          </div>
          <div className="Partenaires-container">
              <img width="100%" height="100%" src={bde} alt="bde" />
          </div>
          <div className="Partenaires-container">
              <img width="150%" height="150%" src={utc} alt="utc" />
          </div>
          <div className="Partenaires-container">
            <img width="100%" height="100%" src={crous} alt="crous" />
          </div>
        </div>
        <div className="Partenaires-container-row">
          <div className="Partenaires-container">
              <img width="150%" height="150%" src={cvec} alt="cvec" />
          </div>
          <div className="Partenaires-container">
              <img width="150%" height="150%" src={HDF} alt="HDF" />
          </div>
          <div className="Partenaires-container">
              <img width="150%" height="150%" src={compi} alt="compi" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Partenairessection
